import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-crown',
    templateUrl: './svg.crown.component.html',
    styleUrls: ['./svg.crown.component.scss'],
    standalone: false
})
export class SvgCrownComponent {
}
